import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { NewsletterInline } from "@/components/Newsletter";
import api from "@/lib/api";

export default function Daily() {
  const [params] = useSearchParams();
  const confirmed = params.get("confirmed");
  const unsubscribed = params.get("unsubscribed");
  const { data: magnet } = useQuery({ queryKey: ["lead-magnet"], queryFn: async () => (await api.get("/lead-magnet")).data });
  const m = magnet?.active;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0B0B0C] px-5 py-16 text-[#E8E4DA]" data-testid="daily-landing">
      <div className="w-full max-w-lg">
        <Link to="/" className="text-xs font-semibold uppercase tracking-[0.2em] text-[#6B6862] hover:text-[#B99A5B]" data-testid="daily-brand">Shubham Bapna</Link>

        {confirmed ? (
          <div className="mt-8" data-testid="daily-confirmed">
            <h1 className="font-serif text-3xl font-normal leading-tight text-white sm:text-4xl">You're confirmed.</h1>
            <p className="mt-5 text-[16px] leading-relaxed text-[#9E9A90]">
              {m ? <>Your copy of <span className="text-white">{m.name}</span> is in your inbox. </> : null}
              The first story lands tomorrow morning. See you then.
            </p>
          </div>
        ) : unsubscribed ? (
          <div className="mt-8" data-testid="daily-unsubscribed">
            <h1 className="font-serif text-3xl font-normal leading-tight text-white sm:text-4xl">You're unsubscribed.</h1>
            <p className="mt-5 text-[16px] leading-relaxed text-[#9E9A90]">No more emails. If you change your mind, you're always welcome back.</p>
          </div>
        ) : (
          <>
            <h1 className="mt-10 font-serif text-3xl font-normal leading-[1.15] text-white sm:text-4xl lg:text-5xl">
              One real business story every morning, and what it means if you run a product business in India.
            </h1>
            {m && (
              <p className="mt-6 text-[16px] leading-relaxed text-[#B99A5B]" data-testid="daily-magnet">
                Confirm your email and I'll send you <span className="font-semibold text-white">{m.name}</span> free — {m.description}
              </p>
            )}
            <div className="mt-8" data-testid="daily-signup"><NewsletterInline source="daily" dark compact /></div>
            <p className="mt-4 text-sm text-[#6B6862]">Free. One email a day. Unsubscribe in one click.</p>
          </>
        )}
      </div>
    </div>
  );
}
